/*
 * @Author: lc
 * @Date: 2022-07-26 15:09:06
 * @LastEditors: lc
 * @LastEditTime: 2023-03-27 08:58:32
 * @Description: 
 */
/**
  * 产品 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const product = {
    // 列表
    list (params) {
        return axios.get(api + 'product/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'product/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'product/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'product/edit', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'product/remove', qs.stringify(params))
    },
    //更改状态
    status (params) {
        return axios.post(api + 'product/status', qs.stringify(params))
    },
    //导出
    export (params) {
        return axios.post(api + 'product/export', qs.stringify(params))
    }
}


// 导出接口
export default product
